import type { FC, ReactNode } from 'react';
import { Card as AntCard } from 'antd';
import type { CardProps as AntCardProps } from 'antd';

export interface CounterCardProps extends Omit<AntCardProps, 'className' | 'style' | 'variant'> {
  children: ReactNode;
  variant?: 'dark' | 'light';
  padding?: 'default' | 'none' | 'sm' | 'lg' | 'compact';
  hover?: boolean;
  className?: string;
}

/**
 * CounterCard - Counter Page Card Component
 * Pixel-perfect card matching camera-detail-page.png design
 */
export const CounterCard: FC<CounterCardProps> = ({
  children,
  variant = 'light',
  padding = 'default',
  hover = false,
  className: customClassName,
  ...antdProps
}) => {
  const baseClasses = 'rounded-[8px] transition-all duration-200';

  const variantClasses = {
    dark: 'bg-fs-card-dark',
    light: 'bg-fs-card-light shadow-sm',
  };

  const paddingClasses = {
    none: 'p-0',
    compact: 'p-2',
    sm: 'p-4',
    default: 'p-5',
    lg: 'p-6',
  };

  const hoverClasses = hover
    ? 'hover:shadow-md hover:-translate-y-0.5 cursor-pointer'
    : '';

  const className = [
    baseClasses,
    variantClasses[variant],
    paddingClasses[padding],
    hoverClasses,
    customClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <AntCard
      {...antdProps}
      variant="borderless"
      className={className}
      styles={{
        body: { padding: 0, height: '100%' },
      }}
    >
      {children}
    </AntCard>
  );
};

